import config from '../../config/config';

export const COST_SCHEDULE_LOAD = 'BILLING/COST_SCHEDULE_LOAD';
export const COST_SCHEDULE_SUCCESS = 'BILLING/COST_SCHEDULE_SUCCESS';
export const COST_SCHEDULE_FAILURE = 'BILLING/COST_SCHEDULE_FAILURE';

export function getCostSchedule() {
    return {
        successActionTypeOrCreator: getCostScheduleSuccessActionCreator,
        fetchParams: {
            url: `${config.billingApiUrl}/userCostSchedule`
        },
        loadActionTypeOrCreator: COST_SCHEDULE_LOAD,
        failureActionTypeOrCreator: getCostScheduleFailureActionCreator
    };
}

export function getCostScheduleSuccessActionCreator(costSchedule) {
    return {
        costSchedule,
        type: COST_SCHEDULE_SUCCESS
    };
}

export function getCostScheduleFailureActionCreator(error) {
    return {
        error,
        type: COST_SCHEDULE_FAILURE
    };
}
